import { F0Select } from '@factorialco/f0-react'
import { Stack } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

const PRIORITY_MODE_OPTIONS = [
  {
    value: 'manual',
    label: () => i18n.t('ticketing.settings.categories.form.priority_modes.manual'),
  },
  {
    value: 'fixed',
    label: () => i18n.t('ticketing.settings.categories.form.priority_modes.fixed'),
  },
]

const PRIORITY_LEVEL_OPTIONS = [
  {
    value: 'critical',
    label: () => i18n.t('ticketing.settings.categories.form.priority_levels.critical'),
  },
  { value: 'high', label: () => i18n.t('ticketing.settings.categories.form.priority_levels.high') },
  {
    value: 'medium',
    label: () => i18n.t('ticketing.settings.categories.form.priority_levels.medium'),
  },
  { value: 'low', label: () => i18n.t('ticketing.settings.categories.form.priority_levels.low') },
]

interface Props {
  priorityMode: string
  fixedPriorityLevel: string | null
  onChange: (field: string, value: string | null) => void
}

const PriorityConfig = ({ priorityMode, fixedPriorityLevel, onChange }: Props) => {
  return (
    <Stack gap="3">
      <F0Select
        label={i18n.t('ticketing.settings.categories.form.priority_mode')}
        value={priorityMode}
        onChange={(value: string) => {
          onChange('priorityMode', value)
          if (value !== 'fixed') {
            onChange('fixedPriorityLevel', null)
          }
        }}
        options={PRIORITY_MODE_OPTIONS.map((o) => ({ value: o.value, label: o.label() }))}
        required
      />
      {priorityMode === 'fixed' && (
        <F0Select
          label={i18n.t('ticketing.settings.categories.form.fixed_priority_level')}
          value={fixedPriorityLevel ?? ''}
          onChange={(value: string) => onChange('fixedPriorityLevel', value)}
          options={PRIORITY_LEVEL_OPTIONS.map((o) => ({ value: o.value, label: o.label() }))}
          required
        />
      )}
    </Stack>
  )
}

export default PriorityConfig
